"use strict";

var _jsxFileName = "/Users/kylemathews/programs/gatsby/packages/gatsby-plugin-jss/src/gatsby-browser.js";

var React = require("react");

var ThemeProvider = require("react-jss").ThemeProvider; // remove the JSS style tag generated on the server to avoid conflicts with the one added on the client


exports.onInitialClientRender = function () {
  var ssStyles = window.document.getElementById("server-side-jss");
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
}; // eslint-disable-next-line react/prop-types


exports.wrapRootElement = function (_ref, options) {
  var element = _ref.element;
  var theme = options.theme || {};
  return React.createElement(ThemeProvider, {
    theme: theme,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: this
  }, element);
};